import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateFixedCostSettings, FixedCostSettings } from '../../../api/FixedCostSettings/fixedCostSettings';

export function useUpdateFixedCostSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (settings: FixedCostSettings) => updateFixedCostSettings(settings),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ 'getFixedCostSettings' ] });
      // Every property's fixed costs depend on these settings.
      queryClient.invalidateQueries({ queryKey: [ 'getEstimatedRepairCosts' ] });
    },
  });
}
